import { EventHelper as ShopEventHelper } from '@shop/frontend/web/js/helpers/EventHelper';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

class EventHelper extends ShopEventHelper {
  /**
   * Создает название для места (например для тултипа)
   * @param {string[]} values - Массив значении в виде: [Место, Ряд, Сектор]
   * @return {string} - Возвращает строку в виде: Ряд 3, место 21
   */
  createPlaceName(values) {
    if (!values[1]) return '';

    return `${translator.t('event', 'Row')} ${values[1]}, ${translator.t('event', 'place')} ${values[0]}`;
  }

  setActivePlaces(carts) {
    $.each(carts, (index, cart) => {
      const selector = $(`#${cart.sid}`);

      selector.attr('data-price', cart.price);
      selector.attr('is_pack', cart.is_pack ? 'true' : 'false');

      selector.addClass('in-cart active');
      if (!cart.is_pack) selector.attr('data-available', 'false');
    });
  }

  setAttributesToPlaces(sectorData) {
    $("#js-change-svg g[mode=2]").addClass("default");

    $.each(sectorData.prices, (index, element) => {
      const id = element.id;
      const zone = this.getZonePropertiesById(element.z, sectorData.zones);
      const price = zone ? zone.price : 0;
      const selector = $(`#${id}`);
      const placeWithoutName = $("#js-places").data("place-without-name");

      if (!selector.attr("data-name")) {
        if (!placeWithoutName)
          selector.attr(
            "data-name",
            sectorData.places_params && sectorData.places_params[id]
              ? this.createPlaceName([
                sectorData.places_params[id].col,
                sectorData.places_params[id].row,
              ])
              : element.n
                ? translator.t("event", element.n)
                : this.createPlaceName(this.splitPlaceId(id))
          );
      }
      selector.attr("data-price", price);
      selector.attr("zone", element.z);
      selector.removeClass("default").addClass("active");
    });

    $.each(sectorData.zones, (index, element) => {
      $(`[zone="${element.zone}"]`).find("rect").each(function () {
        if ($(this).attr("view-mode") !== "2") {
          $(this).css("fill", element.color);
        }
      });

      $(`[zone="${element.zone}"]`).find("ellipse").css("fill", element.color);
      $(`[zone="${element.zone}"]`).find("circle").css("fill", element.color);
      $(`[zone="${element.zone}"]`).find("polygon").css("fill", element.color);
    });
  }
}

export const eventHelper = new EventHelper();
